(() => {
  'use strict';

  const DATA_SELECTOR = '[data-variant-media-data]';

  const MEDIA_ITEM_SELECTORS = [
    '[data-media-id]',
    '[data-product-media-id]',
    '.product__media-item',
    '.product-media__item',
    '.product__gallery-item',
    '.product-gallery__item',
    '.swiper-slide',
    '.splide__slide',
    '.slider__slide'
  ];

  const THUMBNAIL_SELECTORS = [
    '[data-thumbnail-id]',
    '[data-media-id]',
    '[data-product-media-id]',
    '.product__thumbnail',
    '.product-thumbnail',
    '.thumbnail',
    '.swiper-slide',
    '.splide__slide',
    '.slider__slide'
  ];

  class VariantMediaFilter {
    constructor(dataElement) {
      this.dataElement = dataElement;
      this.data = this.parseData();

      if (!this.data) return;

      console.log('VariantMediaFilter initialized:', this.data);

      this.sectionId = String(this.data.sectionId);
      this.productId = String(this.data.productId);
      this.root =
        document.getElementById(`shopify-section-${this.sectionId}`) ||
        this.dataElement.closest('.shopify-section') ||
        document;

      this.productInfo =
        this.root.querySelector(
          `product-info[data-product-id="${this.productId}"]` 
        ) ||
        this.root.querySelector('product-info');

      this.gallery =
        this.root.querySelector('.product__gallery-container') ||
        this.root.querySelector('product-gallery') ||
        this.root;

      this.mediaGallery = this.gallery.querySelector('media-gallery');
      this.sliderGallery = this.gallery.querySelector('slider-element');

      this.activeVariantId = String(this.data.selectedVariantId || '');

      console.log('Gallery:', this.gallery);
      console.log('ProductInfo:', this.productInfo);
      console.log('Active variant ID:', this.activeVariantId);

      this.bindEvents();
      this.observeGallery();
      this.applyFilter(this.activeVariantId);
    }

    refreshGalleryReferences() {
      this.mediaGallery = this.gallery.querySelector('media-gallery');
      this.sliderGallery = this.gallery.querySelector('slider-element');
    }

    parseData() {
      try {
        return JSON.parse(this.dataElement.textContent);
      } catch (error) {
        console.error('Variant media JSON konnte nicht gelesen werden:', error);
        return null;
      }
    }

    bindEvents() {
      const handleVariant = (variant) => {
        if (!variant?.id) return;

        this.applyFilter(String(variant.id));
      };

      /*
       * CUSTOM START — Purpose: Catch this theme's non-bubbling product form variant event. | Date: 2026-07-10 | Dependency: theme ProductInfo variant:change event
       */
      const productForm = this.productInfo?.getAttribute('form')
        ? document.getElementById(this.productInfo.getAttribute('form'))
        : null;

      productForm?.addEventListener('variant:change', (event) => {
        handleVariant(event.detail?.variant);
      });

      if (window.theme?.pubsub?.subscribe && window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
        window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event?.data || event;

          if (data?.productId && String(data.productId) !== this.productId) return;
          if (data?.sectionId && String(data.sectionId) !== this.sectionId) return;

          handleVariant(data?.variant);
        });
      }
      /*
       * CUSTOM END
       */

      document.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;

        if (!variant?.id) return;
        if (!this.eventBelongsToProduct(event)) return;

        this.applyFilter(String(variant.id));
      });

      document.addEventListener('product:variant-change', (event) => {
        const variant = event.detail?.variant;

        if (!variant?.id) return;
        if (!this.eventBelongsToProduct(event)) return;

        this.applyFilter(String(variant.id));
      });

      this.root.addEventListener('change', (event) => {
        const target = event.target;

        if (
          !target.matches(
            'select[name="id"], input[name="id"], input[type="radio"], select'
          )
        ) {
          return;
        }

        window.requestAnimationFrame(() => {
          const variantId = this.getCurrentVariantId();

          if (variantId) {
            this.applyFilter(variantId);
          }
        });
      });

      window.addEventListener('popstate', () => {
        const variantId = this.getVariantIdFromUrl();

        if (variantId) {
          this.applyFilter(variantId);
        }
      });
    }

    eventBelongsToProduct(event) {
      const eventProductId =
        event.detail?.product?.id ||
        event.detail?.productId ||
        event.target?.dataset?.productId;

      if (!eventProductId) return true;

      return String(eventProductId) === this.productId;
    }

    observeGallery() {
      if (!this.gallery || this.gallery === document) return;

      let timeout;

      this.observer = new MutationObserver(() => {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
          this.refreshGalleryReferences();
          this.applyFilter(this.activeVariantId);
        }, 50);
      });

      this.observer.observe(this.gallery, {
        childList: true,
        subtree: true
      });
    }

    getCurrentVariantId() {
      const formId = this.productInfo?.getAttribute('form');

      if (formId) {
        const form = document.getElementById(formId);
        const idInput = form?.querySelector('[name="id"]');

        if (idInput?.value) {
          return String(idInput.value);
        }
      }

      const variantInput = this.root.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );

      if (variantInput?.value) {
        return String(variantInput.value);
      }

      return this.getVariantIdFromUrl() || this.activeVariantId;
    }

    getVariantIdFromUrl() {
      const url = new URL(window.location.href);
      return url.searchParams.get('variant');
    }

    getVariantImages(variantId) {
      const variantData = this.data.variants?.[String(variantId)];

      if (!variantData || !Array.isArray(variantData.images)) {
        return [];
      }

      return variantData.images;
    }

    normalizeUrl(value) {
      if (!value) return '';

      try {
        const url = new URL(value, window.location.origin);

        return decodeURIComponent(url.pathname)
          .replace(/_\d+x\d*(?=\.)/g, '')
          .replace(/_\d+x(?=\.)/g, '')
          .replace(/_\d+x\d+_crop_[^/.]+(?=\.)/g, '')
          .replace(/\.(jpg|jpeg|png|webp|avif)$/i, '')
          .toLowerCase();
      } catch {
        return decodeURIComponent(String(value))
          .split('?')[0]
          .replace(/_\d+x\d*(?=\.)/g, '')
          .replace(/_\d+x(?=\.)/g, '')
          .replace(/\.(jpg|jpeg|png|webp|avif)$/i, '')
          .toLowerCase();
      }
    }

    getElementMediaValues(element) {
      const values = new Set();

      const attributes = [
        'data-media-id',
        'data-product-media-id',
        'data-thumbnail-id',
        'data-id',
        'href'
      ];

      attributes.forEach((attribute) => {
        const value = element.getAttribute?.(attribute);

        if (value) {
          values.add(String(value));
        }
      });

      element.querySelectorAll('img, source, a').forEach((child) => {
        [
          child.getAttribute('src'),
          child.getAttribute('data-src'),
          child.getAttribute('srcset'),
          child.getAttribute('data-srcset'),
          child.getAttribute('href')
        ]
          .filter(Boolean)
          .forEach((value) => {
            value
              .split(',')
              .map((part) => part.trim().split(' ')[0])
              .filter(Boolean)
              .forEach((url) => values.add(url));
          });
      });

      return [...values];
    }

    elementMatchesImage(element, allowedImages) {
      const elementValues = this.getElementMediaValues(element);

      return allowedImages.some((image) => {
        const imageId = String(image.id || '');
        const normalizedImageUrl = this.normalizeUrl(image.url);
        const normalizedFilename = String(image.filename || '')
          .split('.')[0]
          .toLowerCase();

        return elementValues.some((value) => {
          const stringValue = String(value);
          const normalizedValue = this.normalizeUrl(stringValue);

          if (imageId && stringValue.includes(imageId)) {
            return true;
          }

          if (
            normalizedImageUrl &&
            normalizedValue &&
            (
              normalizedValue.includes(normalizedImageUrl) ||
              normalizedImageUrl.includes(normalizedValue)
            )
          ) {
            return true;
          }

          if (
            normalizedFilename &&
            stringValue.toLowerCase().includes(normalizedFilename)
          ) {
            return true;
          }

          return false;
        });
      });
    }

    findMediaItems() {
      const elements = new Set();

      MEDIA_ITEM_SELECTORS.forEach((selector) => {
        this.gallery.querySelectorAll(selector).forEach((element) => {
          if (element.querySelector('img, video, model-viewer')) {
            elements.add(element);
          }
        });
      });

      if (elements.size === 0) {
        this.gallery.querySelectorAll('img').forEach((image) => {
          const item =
            image.closest(
              '[data-media-id], [data-product-media-id], li, slide-element, .swiper-slide'
            ) || image.parentElement;

          if (item) elements.add(item);
        });
      }

      return [...elements];
    }

    findThumbnailItems() {
      const elements = new Set();

      THUMBNAIL_SELECTORS.forEach((selector) => {
        this.gallery.querySelectorAll(selector).forEach((element) => {
          if (
            element.closest(
              '.product__thumbnails, .product-gallery__thumbnails, [data-thumbnails], thumbnails-slider'
            ) ||
            element.matches('[data-thumbnail-id]')
          ) {
            elements.add(element);
          }
        });
      });

      return [...elements];
    }

    applyFilter(variantId) {
      if (!variantId) return;

      const allowedImages = this.getVariantImages(variantId);

      this.activeVariantId = String(variantId);

      /*
       * Kein Metafeld oder leere Bilderliste:
       * Alle Produktbilder sichtbar lassen.
       */
      if (allowedImages.length === 0) {
        this.showAllMedia();
        return;
      }

      const mediaItems = this.findMediaItems();
      const thumbnailItems = this.findThumbnailItems();

      mediaItems.forEach((item) => {
        const visible = this.elementMatchesImage(item, allowedImages);
        this.setElementVisibility(item, visible);
      });

      thumbnailItems.forEach((item) => {
        const visible = this.elementMatchesImage(item, allowedImages);
        this.setElementVisibility(item, visible);
      });

      this.activateFirstVisibleMedia(mediaItems);
      this.updateSliders();
    }

    setElementVisibility(element, visible) {
      element.classList.toggle('custom-variant-media-hidden', !visible);
      element.toggleAttribute('hidden', !visible);
      element.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (visible) {
        element.removeAttribute('inert');
      } else {
        element.setAttribute('inert', '');
      }
    }

    showAllMedia() {
      this.root
        .querySelectorAll('.custom-variant-media-hidden')
        .forEach((element) => {
          element.classList.remove('custom-variant-media-hidden');
          element.removeAttribute('hidden');
          element.removeAttribute('inert');
          element.setAttribute('aria-hidden', 'false');
        });

      this.updateSliders();
    }

    activateFirstVisibleMedia(mediaItems) {
      const visibleItem = mediaItems.find(
        (item) => !item.classList.contains('custom-variant-media-hidden')
      );

      if (!visibleItem) return;

      /*
       * CUSTOM 2026-09-24 — Nie die ganze Seite scrollen, weder beim Laden noch beim
       * Variantenwechsel.
       *
       * mediaGallery.setActiveMedia() (assets/theme.js) ruft intern
       * scrollIntoView({ block: 'start' }) auf dem sichtbaren Medium auf. Ohne "inline"-
       * Angabe scrollt scrollIntoView JEDEN scrollbaren Vorfahren, den es findet — dazu
       * gehoert auch das Browserfenster selbst. Egal ob beim ersten Laden (Constructor) oder
       * bei einem echten Variantenwechsel (Klick auf Farbe/Groesse): Das Ergebnis war
       * jedesmal dasselbe — die ganze Seite sprang so weit nach unten, dass Header und
       * Breadcrumbs aus dem Bild verschwanden. War vorher nur fuer den ersten Aufruf
       * abgesichert (isInitialLoad) — der Sprung kam beim Variantenwechsel aber genauso vor,
       * deshalb jetzt komplett entfernt statt nur fuer den ersten Aufruf gesperrt.
       *
       * sliderGallery.select() bleibt: Das bewegt nur den INTERNEN Slider auf die richtige
       * Position (kein Fenster-Scroll) und sorgt weiterhin dafuer, dass bei einer
       * Slider-Galerie das passende Bild aktiv wird.
       */
      if (this.sliderGallery?.itemsToShow && typeof this.sliderGallery.select === 'function') {
        const visibleIndex = this.sliderGallery.itemsToShow.indexOf(visibleItem);

        if (visibleIndex >= 0) {
          this.sliderGallery.select(visibleIndex + 1, true);
        }
      }
    }

    updateSliders() {
      window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));

        this.root
          .querySelectorAll(
            'slider-element, slider-component, slideshow-component, swiper-container, product-gallery, media-gallery'
          )
          .forEach((slider) => {
            if (typeof slider.reset === 'function') {
              slider.reset();
            }

            if (typeof slider.update === 'function') {
              slider.update();
            }

            if (typeof slider.countMediaGallery === 'function') {
              slider.countMediaGallery();
            }

            if (slider.swiper?.update) {
              slider.swiper.update();
            }
          });
      });
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll(DATA_SELECTOR).forEach((dataElement) => {
      if (dataElement.dataset.variantMediaInitialized === 'true') return;

      dataElement.dataset.variantMediaInitialized = 'true';
      new VariantMediaFilter(dataElement);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
